import React from 'react'
import PropTypes from 'prop-types'
import FormGroup from 'components/FormGroup'
import Label from 'components/Label'
import { ErrorBoundary, HeaderFive } from 'secondstep-components'
import {
  AssignSchoolFieldBox,
  AssignSchoolContainer,
  Input,
  AssignSchoolSelect,
} from './component.styles'
import {
  ASSIGN_SCHOOL_HEADER,
  CITY_SELECT_DATA_TEST_ID,
  CITY_SELECT_LABEL,
  COUNTRY_SELECT_DATA_TEST_ID,
  COUNTRY_SELECT_LABEL,
  REGION_SELECT_DATA_TEST_ID,
  REGION_SELECT_LABEL,
  SCHOOL_IS_NOT_LISTED_WARNING,
  SCHOOL_SELECT_DATA_TEST_ID,
  SCHOOL_NAME_SELECT_LABEL,
  SCHOOL_SELECT_LABEL,
} from './constants'
import { useLocationData } from './hooks/useLocationData'

const AssignSchool = ({ onFormChange, hasRegionData, siteData }) => {
  const { city, country, netSuiteCustomerId, siteName, region } = siteData

  // Use custom hook for location data
  const {
    countries,
    regions,
    cities,
    schools,
    loading,
    error,
  } = useLocationData(country, region, city, hasRegionData, onFormChange)

  return (
    <ErrorBoundary>
      <AssignSchoolContainer>
        <AssignSchoolFieldBox>
          <AssignSchoolSelect
            dataTestId={COUNTRY_SELECT_DATA_TEST_ID}
            label={COUNTRY_SELECT_LABEL}
            name="country"
            onChange={e => onFormChange(e, 'field')}
            value={country}
            data={countries}
            error={error}
            loading={loading}
          />
        </AssignSchoolFieldBox>
        <AssignSchoolFieldBox>
          <AssignSchoolSelect
            dataTestId={REGION_SELECT_DATA_TEST_ID}
            disabled={!hasRegionData || !country}
            label={REGION_SELECT_LABEL}
            name="region"
            onChange={e => onFormChange(e, 'field')}
            value={region}
            data={regions}
            error={error}
            loading={loading}
          />
        </AssignSchoolFieldBox>
      </AssignSchoolContainer>
      <AssignSchoolContainer>
        <AssignSchoolFieldBox>
          <AssignSchoolSelect
            dataTestId={CITY_SELECT_DATA_TEST_ID}
            disabled={!country || (hasRegionData && !region)}
            label={CITY_SELECT_LABEL}
            name="city"
            onChange={e => onFormChange(e, 'field')}
            value={city}
            data={cities}
            error={error}
            loading={loading}
          />
        </AssignSchoolFieldBox>
        <AssignSchoolFieldBox>
          <AssignSchoolSelect
            dataTestId={SCHOOL_SELECT_DATA_TEST_ID}
            disabled={!city || !country}
            label={SCHOOL_SELECT_LABEL}
            name="id"
            onChange={e => onFormChange(e, 'school')}
            onLoadData={data =>
              onFormChange({ target: { value: data } }, 'netSuiteData')
            }
            renderOptions={value => (
              <option key={value.id} value={value.id}>
                {value.companyName}
              </option>
            )}
            value={netSuiteCustomerId?.toString() || ''}
            warning={
              netSuiteCustomerId === 0 ? SCHOOL_IS_NOT_LISTED_WARNING : null
            }
            data={schools}
            error={error}
            loading={loading}
          />
        </AssignSchoolFieldBox>
      </AssignSchoolContainer>
      {netSuiteCustomerId === 0 && (
        <FormGroup>
          <HeaderFive>{ASSIGN_SCHOOL_HEADER}</HeaderFive>
          <Label for="siteName">{SCHOOL_NAME_SELECT_LABEL}</Label>
          <Input
            id="siteName"
            name="siteName"
            onChange={e => onFormChange(e, 'field')}
            value={siteName}
          />
        </FormGroup>
      )}
    </ErrorBoundary>
  )
}

AssignSchool.propTypes = {
  hasRegionData: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  siteData: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string,
    netSuiteCustomerId: PropTypes.number,
    nsCustomerId: PropTypes.string,
    region: PropTypes.string,
    siteName: PropTypes.string,
  }),
}

export default AssignSchool
